import { postJsMessage } from '../../bridge';
import API from '../../api';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from 'types/index';

export type ChatDisplaySize = {
  chatDisplaySize: number;
};
/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * accessibility.getChatDisplaySize
 *
 * [PLATFORM]
 * mac        6.6.0+
 * windows    6.6.0+
 * linux      NotSupport
 * ios        NotSupport
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function getChatDisplaySize(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<ChatDisplaySize>> {
  await isAvailable('accessibility.getChatDisplaySize');
  return postJsMessage<{}, ChatDisplaySize>(
    API.getChatDisplaySize,
    {},
    options
  );
}

export default {
  getChatDisplaySize,
};
